export const ALLOWED_AVATAR_IMAGE_MIME_TYPES: readonly string[] = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/avif',
];

export const ALLOWED_AVATAR_IMAGE_ACCEPT = ALLOWED_AVATAR_IMAGE_MIME_TYPES.join(',');
